import { ReactNode } from "react";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import { cn } from "@/lib/utils";

type PublicSiteLayoutProps = {
  children: ReactNode;
  mainClassName?: string;
};

export default function PublicSiteLayout({ children, mainClassName }: PublicSiteLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className={cn("flex-1", mainClassName)}>{children}</main>
      <Footer />
    </div>
  );
}
